import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'yes_describe_type_deductions_wages_made_besides_legally'

export const dataPointDefinition = {
  retracedId: 'yes_describe_type_deductions_wages_made_besides_legally',
  name: 'If yes, please describe the type of deductions of wages made (besides legally required withholdings and social security)',
  description:
    'Please indicate type and amount ($USD) of the deduction of wages made (besides legally required withholdings and social security).',
  meta: {
    slcpMeta: {
      key: 'wb-19-1f',
      number: 'WB-WAGE-120.1',
      dataType: 'string',
      masterType: 'Follow-up',
      multiSelectKey: '',
      optionList: '',
      versionImported: '1.7.0',
      verificationTypeReq: 'follow-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: '',
      nonCompliance: '',
      humanShowHide: '[2],wb-19,Yes',
      machineShowHide: '[2],wb-19,1',
      completionCondition: 'any',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wb-19-1f', version: '1.7.0', provider: 'slcp'}],
  sortingId: 35170,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
